const CommunicationUtilUrls = {
    POST: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/communication/send`
};

export default CommunicationUtilUrls